import React, { useEffect, useState, useRef } from 'react'
import { toast } from 'react-toastify'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import {
  Grid,
  Button,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  makeStyles,
  FormHelperText,
  CircularProgress,
  IconButton,
  MenuItem,
  Divider,
  DialogContent,
  Dialog,
  Chip
} from '@material-ui/core'
import ViewHeader from 'components/ViewHeader'
import InputAdornment from '@material-ui/core/InputAdornment'
import { useDispatch, useSelector } from 'react-redux'
import ProgressButton from 'components/ProgressButton'
import { useHistory, useParams } from 'react-router-dom'
import { Formik, Form } from 'formik'
import { useConfirm } from 'material-ui-confirm'
import { fetchSessionById } from 'store/session'
import venueSlice, { fetchVenues } from 'store/venue'
import sponsorSlice, { getSponsors } from 'store/sponsor'
import speakerSlice, { getSpeakers } from 'store/speaker'
import {
  addTalk,
  checkNumberExistsInTalks,
  fetchUnAssociatedTalks,
  fetchTalkById,
  getLastNumber,
  resetTalkStore,
  updateTalkById,
  fetchEventOrSessionTalks
} from 'store/talk'
import ActionBar from 'components/ActionBar'
import { fetchEventById } from 'store/event'
import CustomBox from 'components/Form/CustomBox'
import CustomTextField from 'components/Form/CustomTextField'
import DateTimeInput from 'components/DateTimeInput'
import { talkFormSchema } from 'schemas/talk'
import { resetSessionStore } from 'store/session'
import { resetEventStore } from 'store/event'
import { getDefaultTimezone } from 'utils/times'
import moment from 'moment-timezone'
import { caseInsensitiveSort, returnTimeInTimezone } from 'utils'
import pollingSlice, {
  alreadyUsedPoll,
  getMultipleSpeakerPolls,
  pollAttachOrDetach
} from 'store/polling'
import { AssociatedPollMsg, speakerStatus, TalkStatus } from 'constants/index'
import Info from 'components/Info'
import { Add, ArrowDropDown, Warning } from '@material-ui/icons'
import { isDateTimeInRange } from 'utils/talk'
import VenueForm from 'views/admin/venue/VenueForm'
import CustomPopup from 'components/CustomPopup'
import { colors } from 'utils/colors'
import SponsorForm from 'views/admin/sponsors/SponsorForm'
import SpeakerForm from 'views/admin/speakers/SpeakerForm'
import PollingForm from '../subjects/PollingForm/PollingForm'
import { nanoid } from 'nanoid'
import { isEqual } from 'lodash'
import ReactQuill from 'react-quill'
import { modules } from 'views/admin/settings/SettingForm/TemplateForm'

const emptyQuestion = {
  title: '',
  options: [
    { optId: nanoid(), opt: '' },
    { optId: nanoid(), opt: '' }
  ]
}
const pollInitialValues = {
  title: '',
  speakerId: '',
  questions: [emptyQuestion]
}

const TalkForm = () => {
  const classes = useStyles()
  const { eventId, sessionId, talkId } = useParams()
  const dispatch = useDispatch()
  const confirm = useConfirm()
  const history = useHistory()
  const TitleRef = useRef(null)

  const [speakerError, setSpeakerError] = useState('')
  const [selectedSpeakers, setSelectedSpeakers] = useState([])
  const [saveProgress, setSaveProgress] = useState(false)
  const [createNewProgress, setCreateNewProgress] = useState(false)
  const [selectedTalk, setSelectedTalk] = useState(null)
  const [loading, setLoading] = useState(false)
  const [openDropdown, setOpenDropdown] = useState(false)
  const [openVenueModal, setOpenVenueModal] = useState(false)
  const [openSponsorModal, setOpenSponsorModal] = useState(false)
  const [openSpeakerModal, setOpenSpeakerModal] = useState(false)

  const { talk, lastPosterNumber, lastAbstractNumber } = useSelector((state) => state.talk)
  const { user } = useSelector((state) => state.auth)
  const { event } = useSelector((state) => state.event)
  const { session } = useSelector((state) => state.session)
  const { talks } = useSelector((state) => state.talk)
  const { venues } = useSelector((state) => state.venue)
  const { sponsors } = useSelector((state) => state.sponsor)
  const { speakers } = useSelector((state) => state.speaker)
  const { conference } = useSelector((state) => state.conference)
  const { polls, inProgress } = useSelector((state) => state.polling)

  const [openAddPollModal, setOpenAddPollModal] = useState(false)
  const [pollValues, setPollValues] = useState(pollInitialValues)
  const [confirmModal, setConfirmModal] = useState(false)

  const handleCloseModal = (formValues) => {
    if (isEqual(pollValues, formValues)) {
      setOpenAddPollModal(false)
      setPollValues(pollInitialValues)
    } else {
      setConfirmModal(true)
    }
  }

  const handleCloseConfirmModal = () => {
    setConfirmModal(false)
    setOpenAddPollModal(false)
    setPollValues(pollInitialValues)
  }

  const posterPrefix = conference?.posterPrefix
  const abstractPrefix = conference?.abstractPrefix

  const defaultTimezone = getDefaultTimezone(conference?.timezone)

  let lastAbstractNumberSelected = localStorage.getItem('lastAbstractNumberSelected')
  if (!lastAbstractNumberSelected || lastAbstractNumberSelected === 'false') {
    lastAbstractNumberSelected = false
  }

  const initialValues = {
    talk: {
      title: ''
    },
    eventTitle: '',
    sessionTitle: '',
    title: '',
    synopsis: '',
    venueId: '',
    startDate: localStorage.getItem('talkStartDate')
      ? moment(parseInt(localStorage.getItem('talkStartDate'))).tz(
          conference ? conference?.timezone : defaultTimezone
        )
      : moment().tz(conference ? conference?.timezone : defaultTimezone),
    endDate: localStorage.getItem('talkEndDate')
      ? moment(parseInt(localStorage.getItem('talkEndDate'))).tz(
          conference ? conference?.timezone : defaultTimezone
        )
      : moment().tz(conference ? conference?.timezone : defaultTimezone),
    sponsorId: '',
    speakers: [],
    isAbstract: lastAbstractNumberSelected,
    abstractNumber: 1,
    posterNumber: 1,
    havePolls: 'no',
    pollId: ''
  }

  if (session && sessionId && session.id === sessionId) {
    initialValues.sessionTitle = session.title
  }

  if (talk && talkId && talk.id === talkId) {
    initialValues.talk = {
      title: talk.title
    }
    initialValues.title = talk.title
    initialValues.synopsis = talk.synopsis
    initialValues.venueId = talk.venueId
    initialValues.startDate = returnTimeInTimezone(
      talk.startDate,
      conference?.timezone,
      defaultTimezone
    )
    initialValues.endDate = returnTimeInTimezone(
      talk.endDate,
      conference?.timezone,
      defaultTimezone
    )
    initialValues.sponsorId = talk.sponsorId
    initialValues.speakers = talk.speakers
    initialValues.isAbstract = talk.isAbstract ? talk.isAbstract : false
    initialValues.abstractNumber = talk.abstractNumber
      ? talk.abstractNumber
      : lastAbstractNumber
      ? lastAbstractNumber + 1
      : 1
    initialValues.posterNumber = talk.posterNumber
      ? talk.posterNumber
      : lastPosterNumber
      ? lastPosterNumber + 1
      : 1
    initialValues.havePolls = talk.havePolls === true ? 'yes' : 'no'
    initialValues.pollId = talk.pollId
  } else {
    initialValues.abstractNumber = lastAbstractNumber ? lastAbstractNumber + 1 : 1
    initialValues.posterNumber = lastPosterNumber ? lastPosterNumber + 1 : 1
    if (session) {
      if (!moment(initialValues.startDate).isBetween(session.startDate, session.endDate)) {
        initialValues.startDate = returnTimeInTimezone(
          session.startDate,
          conference?.timezone,
          defaultTimezone
        )
        initialValues.endDate = returnTimeInTimezone(
          session.endDate,
          conference?.timezone,
          defaultTimezone
        )
      }
    } else if (event) {
      if (!moment(initialValues.startDate).isBetween(event.startDate, event.endDate)) {
        initialValues.startDate = returnTimeInTimezone(
          event.startDate,
          conference?.timezone,
          defaultTimezone
        )
        initialValues.endDate = returnTimeInTimezone(
          event.endDate,
          conference?.timezone,
          defaultTimezone
        )
      }
    }
  }

  if (!talkId && session && session.id === sessionId) {
    initialValues.venueId = session.venueId
  } else if (!talkId && event && event.id === eventId) {
    initialValues.venueId = event.eventVenue
  }

  useEffect(() => {
    if (conference?.speakerCanUploadTalks) {
      dispatch(fetchUnAssociatedTalks(user?.conferenceId))
    }
  }, [conference?.speakerCanUploadTalks])

  useEffect(() => {
    const unsubVenues = fetchVenues(user?.conferenceId, (venuesData) => {
      dispatch(venueSlice.actions.setVenues(venuesData))
    })
    const fetchData = async () => {
      setLoading(true)
      if (eventId) {
        await dispatch(fetchEventById(eventId))
      }
      if (talkId) {
        await dispatch(fetchTalkById(talkId))
      }
      if (sessionId) {
        await dispatch(fetchSessionById(sessionId))
      }
      if (event) {
        event.isPosterSession
          ? await dispatch(getLastNumber('posterNumber'))
          : await dispatch(getLastNumber('abstractNumber'))
      } else {
        await dispatch(getLastNumber('abstractNumber'))
      }
      setLoading(false)
    }
    fetchData()
    return () => {
      unsubVenues && unsubVenues()
      dispatch(resetTalkStore())
      dispatch(resetSessionStore())
      dispatch(resetEventStore())
    }
  }, [user?.conferenceId])

  useEffect(() => {
    const unsub = getSponsors(user?.conferenceId, (data) => {
      dispatch(sponsorSlice.actions.setSponsors(caseInsensitiveSort(data, 'fullName')))
    })
    const unsubSpeakers = getSpeakers(user?.conferenceId, (data) => {
      dispatch(speakerSlice.actions.setSpeakers(caseInsensitiveSort(data, 'fullName')))
    })
    return () => {
      unsub && unsub()
      unsubSpeakers && unsubSpeakers()
    }
  }, [user?.conferenceId])

  const goBack = () => {
    dispatch(resetTalkStore())
    dispatch(resetSessionStore())
    dispatch(resetEventStore())
    history.goBack()
  }

  useEffect(() => {
    if (talk?.speakers?.length) {
      setSelectedSpeakers(talk.speakers)
    }
  }, [talk?.speakers])

  useEffect(() => {
    if (conference?.havePolls && selectedSpeakers?.length) {
      dispatch(getMultipleSpeakerPolls(user?.conferenceId, selectedSpeakers))
    } else dispatch(pollingSlice.actions.setPolls([]))
  }, [selectedSpeakers, conference?.havePolls])

  const onSubmit = async (
    {
      talk: talkPayload,
      synopsis,
      startDate,
      endDate,
      sponsorId,
      venueId,
      havePolls,
      pollId,
      isAbstract,
      abstractNumber,
      posterNumber
    },
    { setFieldError }
  ) => {
    const sDate = typeof startDate === 'number' ? startDate : startDate.valueOf()
    const eDate =
      typeof endDate === 'number' ? endDate : endDate.seconds(0).milliseconds(0).valueOf()

    const compStartDate = session?.startDate || event?.startDate
    const compEndDate = session?.endDate || event?.endDate
    const compType = session ? 'session' : 'event'

    let hasError = false
    if (sDate < compStartDate) {
      setFieldError('startDate', {
        errType: 'Time',
        msg: `Start time can not be before ${compType} start time`
      })
      hasError = true
    }

    if (sDate > compEndDate) {
      setFieldError('startDate', {
        errType: 'Time',
        msg: `Start time can not be after ${compType} end time`
      })
      hasError = true
    }

    if (eDate < compStartDate) {
      setFieldError('endDate', {
        errType: 'Time',
        msg: `End time can not be before ${compType} start time`
      })
      hasError = true
    }

    if (eDate > compEndDate) {
      setFieldError('endDate', {
        errType: 'Time',
        msg: `End time can not be after ${compType} end time`
      })
      hasError = true
    }

    if (havePolls === 'yes' && !selectedSpeakers.length) {
      setSpeakerError('Please select at least one speaker.')
      hasError = true
    }

    if (havePolls === 'yes' && !pollId) {
      setFieldError('pollId', 'Associated poll is a required field')
      hasError = true
    }
    if (hasError) return

    const payload = {
      title: talkPayload.title.trim(),
      synopsis: synopsis.trim(),
      startDate: moment(sDate).utc().valueOf(),
      endDate: moment(eDate).utc().valueOf(),
      sponsorId: sponsorId,
      venueId: venueId,
      speakers: selectedSpeakers,
      havePolls: havePolls === 'yes',
      pollId: havePolls === 'yes' && pollId ? pollId : null,
      eventId: eventId,
      sessionId: sessionId ? sessionId : '',
      isAbstract,
      conferenceId: user?.conferenceId
    }

    if (!hasError && !payload.isAbstract) {
      const existingTalks = await fetchEventOrSessionTalks(eventId, sessionId)
      const filteredTalks = talkId
        ? existingTalks.filter((talk) => talk.id !== talkId)
        : existingTalks
      if (existingTalks?.length) {
        const res = isDateTimeInRange(
          payload?.startDate,
          payload?.endDate,
          payload.venueId,
          filteredTalks
        )
        if (res) {
          toast.warning('Talk start time overlaps with another talk.')
          return
        }
      }
    }

    let numberAlreadyExists = null,
      confirmTitle,
      res = null,
      message
    if (isAbstract) {
      if (event && event.isPosterSession) {
        payload.posterNumber = posterNumber
        numberAlreadyExists = await dispatch(
          checkNumberExistsInTalks('posterNumber', posterNumber, talkId)
        )
        confirmTitle = 'This Poster Number already exists for some other talk.'
      } else {
        payload.abstractNumber = abstractNumber
        numberAlreadyExists = await dispatch(
          checkNumberExistsInTalks('abstractNumber', abstractNumber, talkId)
        )
        confirmTitle = 'This Abstract Number already exists for some other talk.'
      }

      if (numberAlreadyExists) {
        try {
          setSaveProgress(false)
          await confirm({
            title: confirmTitle,
            description: 'Do you still wish to continue ?'
          })
        } catch {
          return false
        }
      }
    } else {
      payload['abstractNumber'] = null
      payload['posterNumber'] = null
    }

    setSaveProgress(true)
    if (talkId && !selectedTalk?.id) {
      if (payload.havePolls && talk?.pollId !== payload.pollId) {
        const isAlreadyUsed = await alreadyUsedPoll(payload.pollId)
        if (isAlreadyUsed) {
          toast.warning(AssociatedPollMsg)
          setSaveProgress(false)
          return
        }
      }
      if ((payload.havePolls && talk?.pollId !== payload?.pollId) || !payload.havePolls) {
        await pollAttachOrDetach(talk?.pollId, {
          eventId: null,
          sessionId: null,
          talkId: null,
          alreadyUsed: false
        })
      }
      res = await dispatch(updateTalkById(talkId, payload))
      message = 'Talk updated successfully'
    } else if (talkId && selectedTalk?.id) {
      if (payload.havePolls && selectedTalk?.pollId !== payload.pollId) {
        const isAlreadyUsed = await alreadyUsedPoll(payload.pollId)
        if (isAlreadyUsed) {
          toast.warning(AssociatedPollMsg)
          setSaveProgress(false)
          return
        }
      }
      await dispatch(
        updateTalkById(selectedTalk?.id, { ...payload, status: TalkStatus.ASSOCIATED })
      )
      res = await dispatch(
        updateTalkById(talkId, {
          ...talk,
          eventId: '',
          sessionId: '',
          venueId: '',
          sponsorId: '',
          startDate: '',
          endDate: '',
          isAbstract: false,
          status: TalkStatus.NOT_ASSOCIATED
        })
      )
      setSaveProgress(false)
      message = 'Talk updated successfully'
    } else if (!talkId && selectedTalk?.id) {
      if (selectedTalk?.pollId !== payload?.pollId) {
        const isAlreadyUsed = await alreadyUsedPoll(payload?.pollId)
        if (isAlreadyUsed) {
          toast.warning(AssociatedPollMsg)
          setSaveProgress(false)
          return
        }
      }
      res = await dispatch(
        updateTalkById(selectedTalk?.id, {
          ...payload,
          status: TalkStatus.ASSOCIATED
        })
      )
      message = 'Talk created successfully'
    } else if (payload?.havePolls) {
      const isAlreadyUsed = await alreadyUsedPoll(payload?.pollId)
      if (isAlreadyUsed) {
        toast.warning(AssociatedPollMsg)
        setSaveProgress(false)
        return
      }
      res = await dispatch(addTalk(payload))
      message = 'Talk created successfully'
    } else {
      res = await dispatch(addTalk(payload))
      message = 'Talk created successfully'
    }

    if (payload?.havePolls && payload?.pollId) {
      await pollAttachOrDetach(payload.pollId, {
        eventId: event?.id ?? null,
        sessionId: session?.id ?? null,
        talkId: talkId && selectedTalk?.id ? selectedTalk?.id : talkId ? talkId : res,
        alreadyUsed: true
      })
    }

    if (res) {
      localStorage.setItem('talkStartDate', payload.endDate)
      localStorage.setItem('talkEndDate', payload.endDate + (payload.endDate - payload.startDate))
      localStorage.setItem('lastAbstractNumberSelected', isAbstract)
      toast(message, {
        type: 'success',
        autoClose: 3000
      })
      return true
    }
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: '5rem' }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box onClick={() => setOpenDropdown(false)}>
      <CustomBox>
        <ViewHeader title={talkId ? 'Edit talk' : 'Create talk'}>
          <div style={{ marginRight: 10 }}>
            <ActionBar actionText="Back" onAction={goBack} />
          </div>
        </ViewHeader>
        {event && eventId === event.id && (
          <Info
            eventTitle={event.title}
            eventStartDate={event?.startDate}
            eventEndDate={event?.endDate}
            sessionTitle={session?.title}
            sessionStartDate={session?.startDate}
            sessionEndDate={session?.endDate}
            timezone={conference?.timezone}
            is24hrFormat={conference?.is24hrFormat}
          />
        )}
        <Formik
          enableReinitialize={!!talkId}
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={talkFormSchema}>
          {({
            values,
            setFieldValue,
            isValid,
            errors,
            touched,
            validateForm,
            submitForm,
            resetForm,
            handleReset
          }) => (
            <Form className={classes.form}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                  {conference?.speakerCanUploadTalks ? (
                    <Autocomplete
                      open={openDropdown}
                      openOnFocus={false}
                      disableClearable
                      selectOnFocus
                      options={talks}
                      popupIcon={
                        talks?.length ? (
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation()
                              setOpenDropdown((prev) => !prev)
                            }}
                            className={classes.iconBtn}>
                            <ArrowDropDown />
                          </IconButton>
                        ) : (
                          <></>
                        )
                      }
                      getOptionLabel={(option) =>
                        typeof option === 'string' ? option : option?.title
                      }
                      value={selectedTalk ?? values.talk}
                      onChange={(e, value) => {
                        dispatch(pollingSlice.actions.setPolls([]))
                        setSelectedTalk(value)
                        setFieldValue('talk.title', value?.title)
                        setFieldValue('synopsis', value?.synopsis)
                        let start, end
                        if (eventId) {
                          start = sessionId ? session?.startDate : event?.startDate
                          end = sessionId ? session?.endDate : event?.endDate
                        }
                        setFieldValue(
                          'startDate',
                          moment(start).tz(conference?.timezone ?? defaultTimezone)
                        )
                        setFieldValue(
                          'endDate',
                          moment(end).tz(conference?.timezone ?? defaultTimezone)
                        )
                        setSelectedSpeakers(value?.speakers?.length ? [...value.speakers] : [])
                        setFieldValue('havePolls', value?.havePolls ? 'yes' : 'no')
                        setFieldValue('pollId', value?.pollId)
                        setOpenDropdown(false)
                        TitleRef.current && TitleRef.current.focus()
                      }}
                      onInputChange={(e, inputValue) => {
                        if (e?.type === 'change') {
                          setFieldValue('talk.title', inputValue)
                          setSelectedTalk(null)
                          if (values.talk?.title && selectedTalk?.id) {
                            setFieldValue('talk.title', '')
                            setFieldValue('synopsis', '')
                            setSelectedSpeakers([])
                            setFieldValue('havePolls', 'no')
                            setFieldValue('pollId', '')
                          }
                        }
                      }}
                      onBlur={(e) => {
                        if (e?.type === 'blur' && selectedTalk?.id) {
                          setFieldValue('talk.title', selectedTalk?.title)
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          inputRef={TitleRef}
                          label="Talk Title"
                          name="talk.title"
                          type="text"
                          error={!!(touched.talk?.title && errors.talk?.title)}
                          helperText={
                            touched.talk?.title && errors.talk?.title ? errors.talk?.title : ''
                          }
                          variant="outlined"
                        />
                      )}
                    />
                  ) : (
                    <CustomTextField label="Talk Title" name="talk.title" type="text" />
                  )}
                </Grid>

                <Grid item xs={12} lg={4}>
                  <TextField
                    select
                    fullWidth
                    label="Venue"
                    variant="outlined"
                    error={Boolean(touched.venueId && errors.venueId)}
                    value={values.venueId}
                    onChange={(event) =>
                      event.target.value && setFieldValue('venueId', event.target.value)
                    }
                    helperText={touched.venueId && errors.venueId ? errors.venueId : null}>
                    {venues?.map((venue) => (
                      <MenuItem value={venue.id} key={venue.id}>
                        <Typography>{venue.venueText}</Typography>
                      </MenuItem>
                    ))}
                    <Divider />
                    <MenuItem onClick={() => setOpenVenueModal(true)}>
                      <Typography className={classes.buttonItem}>
                        <Add />
                        Create venue
                      </Typography>
                    </MenuItem>
                  </TextField>
                </Grid>

                <Grid item xs={12} lg={8}>
                  <Grid container>
                    <Grid item xs={12} lg={6}>
                      <DateTimeInput
                        value={values.startDate}
                        dateLabel="Talk Start Date"
                        timeLabel="Talk Start Time"
                        name="startDate"
                        is24hrFormat={conference?.is24hrFormat}
                        minDate={returnTimeInTimezone(
                          session?.startDate || event?.startDate,
                          conference?.timezone,
                          defaultTimezone
                        )}
                        maxDate={returnTimeInTimezone(
                          session?.endDate || event?.endDate,
                          conference?.timezone,
                          defaultTimezone
                        )}
                        onChange={(value) => {
                          setFieldValue('startDate', value)
                          if (!talkId) {
                            setFieldValue('endDate', value)
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <DateTimeInput
                        value={values.endDate}
                        dateLabel="Talk End Date"
                        timeLabel="Talk End Time"
                        name="endDate"
                        is24hrFormat={conference?.is24hrFormat}
                        minDate={returnTimeInTimezone(
                          session?.startDate || event?.startDate,
                          conference?.timezone,
                          defaultTimezone
                        )}
                        maxDate={returnTimeInTimezone(
                          session?.endDate || event?.endDate,
                          conference?.timezone,
                          defaultTimezone
                        )}
                        onChange={(value) => setFieldValue('endDate', value)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Typography>
                    Add {event && event.isPosterSession ? 'Poster number' : 'Abstract number'} ?{' '}
                  </Typography>
                  <RadioGroup row>
                    <FormControlLabel
                      control={<Radio />}
                      label="Yes"
                      checked={values && values.isAbstract}
                      onChange={() => setFieldValue('isAbstract', true)}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      label="No"
                      checked={values && !values.isAbstract}
                      onChange={() => setFieldValue('isAbstract', false)}
                    />
                  </RadioGroup>
                </Grid>
                {values && values.isAbstract && (
                  <Grid item xs={12} lg={4}>
                    <CustomTextField
                      label={event && event.isPosterSession ? 'Poster number' : 'Abstract number'}
                      name={event && event.isPosterSession ? 'posterNumber' : 'abstractNumber'}
                      type="number"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {event && event.isPosterSession ? posterPrefix : abstractPrefix}
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                    <label htmlFor="synopsis" className={classes.label}>
                      Synopsis
                    </label>
                    <ReactQuill
                      id="synopsis"
                      theme="snow"
                      modules={modules}
                      value={values.synopsis}
                      onChange={(value) => setFieldValue('synopsis', value)}
                      placeholder="Write synposis here..."
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} lg={6}>
                  <TextField
                    select
                    fullWidth
                    label="Sponsor"
                    variant="outlined"
                    error={Boolean(touched.sponsorId && errors.sponsorId)}
                    value={values.sponsorId}
                    onChange={(event) =>
                      event.target.value && setFieldValue('sponsorId', event.target.value)
                    }
                    helperText={touched.sponsorId && errors.sponsorId ? errors.sponsorId : null}>
                    {sponsors?.map((sponsor) => (
                      <MenuItem value={sponsor.id} key={sponsor.id}>
                        <Typography>{sponsor.fullName}</Typography>
                      </MenuItem>
                    ))}
                    <Divider />
                    <MenuItem onClick={() => setOpenSponsorModal(true)}>
                      <Typography className={classes.buttonItem}>
                        <Add />
                        Create sponsor
                      </Typography>
                    </MenuItem>
                  </TextField>
                </Grid>

                <Grid item xs={12} md={12} lg={6}>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    variant="outlined"
                    options={[...speakers, { fullName: 'Create speaker', isOption: false }]}
                    onChange={(e, value) => {
                      if (
                        Array.isArray(value) &&
                        value.length &&
                        value[value.length - 1].isOption === false
                      ) {
                        setOpenSpeakerModal(true)
                        return
                      }
                      const speakerIds = value.map((speaker) => speaker.id)
                      setSpeakerError('')
                      setSelectedSpeakers(speakerIds)
                    }}
                    renderOption={(option) => {
                      return option.isOption === false ? (
                        <li className={classes.nonSelectedMenu}>
                          <Typography className={classes.buttonItem}>
                            <Add />
                            Create speaker
                          </Typography>
                        </li>
                      ) : (
                        <li className={classes.listItem}>
                          {option?.isSubject && option?.fullName
                            ? option?.fullName
                            : option?.isSubject && !option?.fullName
                            ? option.email
                            : option.fullName}
                          {option?.isSubject && option?.status === speakerStatus.PENDING && (
                            <Chip
                              size="small"
                              className={classes.chip}
                              color="primary"
                              label={
                                <Typography className={classes.chipLabel}>
                                  {option?.status === speakerStatus.PENDING
                                    ? 'Not Approved'
                                    : 'Approved'}
                                </Typography>
                              }
                            />
                          )}
                        </li>
                      )
                    }}
                    getOptionLabel={(option) => option?.fullName}
                    value={selectedSpeakers.map((speakerId) =>
                      speakers.find((speaker) => speaker.id === speakerId)
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={Boolean(speakerError)}
                        variant="outlined"
                        label="Speakers"
                        placeholder="Speakers"
                      />
                    )}
                  />
                  {speakerError && (
                    <FormHelperText className={classes.error}>{speakerError}</FormHelperText>
                  )}
                </Grid>

                {conference?.havePolls && (
                  <>
                    <Grid item xs={12} md={12}>
                      <Box className={classes.radioGroup}>
                        <Typography className={classes.radioLabel}>
                          Do you want to associate a poll with this talk?
                        </Typography>
                        <RadioGroup
                          row
                          value={values.havePolls}
                          onChange={(e) => {
                            setFieldValue('havePolls', e.target.value)
                            if (e.target.value === 'no' && speakerError) {
                              setSpeakerError('')
                            }
                          }}>
                          <FormControlLabel
                            control={<Radio size="small" />}
                            label={<Typography variant="body2">Yes</Typography>}
                            value="yes"
                          />
                          <FormControlLabel
                            control={<Radio size="small" />}
                            label={<Typography variant="body2">No</Typography>}
                            value="no"
                          />
                        </RadioGroup>
                      </Box>
                    </Grid>
                    {values.havePolls === 'yes' && (
                      <Grid item xs={12} lg={6}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                          <TextField
                            select
                            fullWidth
                            disabled={inProgress}
                            label="Associated Poll"
                            variant="outlined"
                            error={Boolean(touched.pollId && errors.pollId)}
                            value={values.pollId}
                            onChange={(event) =>
                              event.target.value && setFieldValue('pollId', event.target.value)
                            }
                            helperText={touched.pollId && errors.pollId ? errors.pollId : null}>
                            {polls?.map((poll) => (
                              <MenuItem value={poll.id} key={poll.id}>
                                <Typography>{poll.title}</Typography>
                              </MenuItem>
                            ))}
                            <Divider />
                            <MenuItem onClick={() => setOpenAddPollModal(true)}>
                              <Typography className={classes.buttonItem}>
                                <Add />
                                Create poll
                              </Typography>
                            </MenuItem>
                          </TextField>
                          {inProgress && <CircularProgress size={20} />}
                        </Box>
                      </Grid>
                    )}
                  </>
                )}
              </Grid>
              <Grid container spacing={2} className={classes.actionButtons}>
                <Grid item>
                  <Button size="large" onClick={() => goBack()}>
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <ProgressButton
                    type="button"
                    label="Save"
                    inProgress={saveProgress}
                    disabled={saveProgress || createNewProgress}
                    onClick={async () => {
                      setSaveProgress(true)
                      await validateForm()
                      if (isValid) {
                        const submitStatus = await submitForm()
                        setSaveProgress(false)
                        submitStatus && goBack()
                      } else setSaveProgress(false)
                    }}
                  />
                </Grid>
                <Grid item>
                  <ProgressButton
                    type="button"
                    label="Save and Create New"
                    inProgress={createNewProgress}
                    disabled={createNewProgress || saveProgress}
                    onClick={async () => {
                      setCreateNewProgress(true)
                      await validateForm()
                      const submitStatus = await submitForm()
                      setCreateNewProgress(false)
                      setSaveProgress(false)
                      if (submitStatus && isValid) {
                        handleReset()
                        resetForm()
                        setSelectedTalk(null)
                        setSelectedSpeakers([])
                        dispatch(resetTalkStore())
                        dispatch(fetchUnAssociatedTalks(user?.conferenceId))
                        setFieldValue(
                          'startDate',
                          moment(parseInt(localStorage.getItem('talkStartDate'))).tz(
                            conference ? conference?.timezone : defaultTimezone
                          )
                        )
                        setFieldValue(
                          'endDate',
                          moment(parseInt(localStorage.getItem('talkEndDate'))).tz(
                            conference ? conference?.timezone : defaultTimezone
                          )
                        )
                        const isAbstractTalk = localStorage.getItem('lastAbstractNumberSelected')
                        setFieldValue('isAbstract', isAbstractTalk === 'true')
                        if (isAbstractTalk === 'true' && event?.isPosterSession) {
                          const lastPosNum = await dispatch(getLastNumber('posterNumber'))
                          setFieldValue('posterNumber', lastPosNum + 1)
                        } else if (isAbstractTalk === 'true' && !event?.isPosterSession) {
                          const lastAbsNum = await dispatch(getLastNumber('abstractNumber'))
                          setFieldValue('abstractNumber', lastAbsNum + 1)
                        }
                        if (sessionId) {
                          history.replace(
                            `/admin/events/${eventId}/sessions/${sessionId}/talks/new`
                          )
                        } else {
                          history.replace(`/admin/events/${eventId}/talks/new`)
                        }
                      }
                    }}
                  />
                </Grid>
              </Grid>
              <Dialog fullWidth maxWidth="xl" open={openAddPollModal}>
                <DialogContent className={classes.pollModalContent}>
                  <PollingForm
                    forApproval={true}
                    editedPollId={null}
                    pollValues={pollValues}
                    speakerId={null}
                    conferenceId={user?.conferenceId}
                    associateSpeaker={true}
                    subjectId={null}
                    handleCloseModal={handleCloseModal}
                    handleCloseConfirmModal={() => setOpenAddPollModal(false)}
                    onSuccess={(pollId, speakerId) => {
                      setFieldValue('pollId', pollId)
                      if (!selectedSpeakers.includes(speakerId)) {
                        setSelectedSpeakers((prevState) => [...prevState, speakerId])
                      } else {
                        dispatch(getMultipleSpeakerPolls(user?.conferenceId, selectedSpeakers))
                      }
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                fullWidth
                maxWidth="sm"
                open={confirmModal}
                onClose={() => setConfirmModal(false)}>
                <Box className={classes.warningModalHeader}>
                  <Warning className={classes.warningIcon} />
                  <Typography className={classes.warningTitle}>Warning</Typography>
                </Box>
                <DialogContent className={classes.modalContent}>
                  <Typography variant="body2">
                    Any unsaved data will be lost. Press CANCEL to go back and save these changes,
                    or OK to discard these changes.
                  </Typography>

                  <Box className={classes.actions}>
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={handleCloseConfirmModal}>
                      ok
                    </Button>
                    <Button size="medium" onClick={() => setConfirmModal(false)}>
                      cancel
                    </Button>
                  </Box>
                </DialogContent>
              </Dialog>
              <CustomPopup
                title="Create venue"
                maxWidth="lg"
                open={openVenueModal}
                onClose={() => setOpenVenueModal(false)}>
                <VenueForm
                  displayContext="modal"
                  onCloseModal={() => setOpenVenueModal(false)}
                  onSuccess={(venueId) => {
                    setOpenVenueModal(false)
                    setFieldValue('venueId', venueId)
                  }}
                />
              </CustomPopup>
              <CustomPopup
                title="Create sponsor"
                maxWidth="lg"
                open={openSponsorModal}
                onClose={() => setOpenSponsorModal(false)}>
                <SponsorForm
                  displayContext="modal"
                  onCloseModal={() => setOpenSponsorModal(false)}
                  onSuccess={(sponsorId) => {
                    setOpenSponsorModal(false)
                    setFieldValue('sponsorId', sponsorId)
                  }}
                />
              </CustomPopup>
              <CustomPopup
                title="Create speaker"
                maxWidth="lg"
                open={openSpeakerModal}
                onClose={() => setOpenSpeakerModal(false)}>
                <SpeakerForm
                  displayContext="modal"
                  onCloseModal={() => setOpenSpeakerModal(false)}
                  onSuccess={(speakerId) => {
                    setOpenSpeakerModal(false)
                    setSelectedSpeakers((prevState) => [...prevState, speakerId])
                  }}
                />
              </CustomPopup>
            </Form>
          )}
        </Formik>
      </CustomBox>
    </Box>
  )
}
export default TalkForm

const useStyles = makeStyles({
  label: {
    fontSize: '13px',
    letterSpacing: '0.5px',
    color: '#606060'
  },
  chipLabel: {
    fontSize: '13px',
    letterSpacing: '0.5px',
    fontWeight: 'bold'
  },
  chip: {
    background: '#c62828',
    color: '#FFFFFF'
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  pollModalContent: {
    paddingTop: '0px !important',
    paddingBottom: '0px'
  },
  radioGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  radioLabel: {
    fontWeight: 600,
    fontSize: '16px',
    color: '#2f2f2f'
  },
  error: {
    marginTop: '5px',
    marginLeft: '15px',
    color: '#ec2625'
  },
  actionButtons: {
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'end'
  },
  form: {
    marginTop: '2.5rem'
  },
  iconBtn: {
    padding: '0px'
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  },
  buttonItem: {
    color: colors.indigo,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '0.3rem'
  },
  warningModalHeader: {
    padding: '20px 20px 10px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  warningIcon: {
    color: '#ffa726'
  },
  warningTitle: {
    fontSize: '16px',
    fontWeight: 'bold'
  },
  modalContent: {
    padding: '4px 16px 4px 22px'
  },
  actions: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginBottom: '10px'
  },
  nonSelectedMenu: {
    backgroundColor: 'transparent !important'
  }
})
